import { render } from "./SessionGuard.vue?vue&type=template&id=d2cec612&scoped=true"
import script from "./SessionGuard.vue?vue&type=script&lang=js"
export * from "./SessionGuard.vue?vue&type=script&lang=js"

import "./SessionGuard.vue?vue&type=style&index=0&id=d2cec612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2cec612"]])

export default __exports__